var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VJsoneditor',{attrs:{"height":"600px","options":_vm.options,"plus":false},on:{"input":_vm.update},model:{value:(_vm.objectJSON),callback:function ($$v) {_vm.objectJSON=$$v},expression:"objectJSON"}})}
var staticRenderFns = []

export { render, staticRenderFns }